import React, { ReactNode, useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { message } from "antd";
import sendSoapRequest from "../../services/soapApiListePresse";
import { PressData } from "../../models/listpress";
import LoaderSupport from "../LoaderSupport";
import { TabStypeItem } from "../../models/typeAnnonce";
import {
  getCitiesByPostalCode,
  getCitiesByPostalCodeString,
} from "../../services/postal_code_service";
import { getUserDetails } from "../../services/User_service";
import "../../css/loader-support.css";
import { isValidPostalCode } from "../../utils/functions/validatePostalCode";
import useAppContext from "../../hooks/useAppContext";
import { AppContextType } from "../../context/AppContext";
import { getDepartementCode } from "../../services/getDepartmentCodeOfPostalCode";
import { getJalList, Jal } from "../../services/JalService";
import TypeAnnoncePercentagesService from "../../services/TypeAnnoncePercentagesService";
import "../../css/supportPresse.css"

interface SupportPresseProps {
  selectedSupport: PressData | null;
  selectedType: TabStypeItem | null;
  onSupportSelect: (selectedSupport: PressData) => void;
  txtAnnonce: string;
  nJustif: number;
  entete: string;
  floid: string;
  logoLibelle?: string;
  updateTxtAnnonce: (newTxt: string) => void;
  pressData: PressData[];
  setPressData: (data: PressData[]) => void;
  postalCodeProp?: string;
}

function SupportPresse({
  selectedType,
  onSupportSelect,
  txtAnnonce,
  nJustif,
  pressData,
  setPressData,
  postalCodeProp,
  entete,
  floid,
  logoLibelle = "",
  selectedSupport,
}: SupportPresseProps) {
  const {
    headOfficeAddress,
    legalEntity,
    address,
    individual,
    spousesAddress,
    residentialAddress,
    legalEntityofficiant,
    pressSupportPostalCode,
    setPressSupportPostalCode,
    pressSupportCity,
    setPressSupportCity,
    currentAnnoucement,
    choix,
  } = useAppContext() as AppContextType;

  const [loading, setLoading] = useState<boolean>(true);
  const [jalList, setJalList] = useState<Jal[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [initialPostalCode, setInitialPostalCode] = useState<string>("");
  const [selectedItem, setSelectedItem] = useState<number | null>(null);
  const selectedPress = selectedItem !== null ? pressData[selectedItem] : null;
  const [cities, setCities] = useState<string[]>([]);
  const [isTableLoading, setIsTableLoading] = useState<boolean>(false);
  const [inputDisabled, setInputDesabled] = useState<boolean>(false);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [user, setUser] = useState({
    name: "",
    firstname: "",
    email: "",
    reference: "",
    civility: "",
    code_parrainage: "",
    adresse: "",
    number: "",
    country: "",
    postal_code: "",
    dateCreation: "",
    raison_social: "",
    code_SIREN: "",
    code_NAF: "",
    tv_intra: "",
    status:""
  });

  const API_URL = process.env.REACT_APP_API_BASE;

  const [typeAnnoncePercentages, setTypeAnnoncePercentages] = useState<{
    [key: number]: { discountPercentage: number };
  }>({});

  useEffect(() => {
    const fetchPercentages = async () => {
      try {
        const response = await TypeAnnoncePercentagesService.getPercentages();
        const formattedData = response.data.reduce((acc: any, item: any) => {
          acc[item.nSType] = item;
          return acc;
        }, {});
        setTypeAnnoncePercentages(formattedData);
      } catch (err) {
        setTypeAnnoncePercentages({});
      }
    };
    fetchPercentages();
  }, []);

  useEffect(() => {
    const getPostalCodeIfExists = () => {
      let alreadySetCity = pressSupportCity && pressSupportCity !== "";
      if (currentAnnoucement) {
        setPressSupportPostalCode(currentAnnoucement.postal_code);
        setInitialPostalCode(currentAnnoucement.postal_code);
        setCities([currentAnnoucement.city]);
        if (!alreadySetCity) setPressSupportCity(currentAnnoucement.city);
      } else if (postalCodeProp) {
        setPressSupportPostalCode(postalCodeProp);
        setInitialPostalCode(postalCodeProp);
        getCitiesByPostalCode(Number(postalCodeProp)).then((value) => {
          setCities(value);
          if (!alreadySetCity) setPressSupportCity(value?.[0]);
        });
      } else if (legalEntityofficiant.postalCode) {
        setPressSupportPostalCode(legalEntityofficiant.postalCode);
        setInitialPostalCode(legalEntityofficiant.postalCode);
        setCities(legalEntityofficiant.cities ?? []);
        if (!alreadySetCity) setPressSupportCity(legalEntityofficiant.cities?.[0] || "");
      } else if (residentialAddress.postalCode) {
        setPressSupportPostalCode(residentialAddress.postalCode);
        setInitialPostalCode(residentialAddress.postalCode);
        setCities(residentialAddress.cities ?? []);
        if (!alreadySetCity) setPressSupportCity(residentialAddress.cities?.[0] || "");
      } else if (spousesAddress.postalCode) {
        setPressSupportPostalCode(spousesAddress.postalCode);
        setInitialPostalCode(spousesAddress.postalCode);
        setCities(spousesAddress.cities ?? []);
        if (!alreadySetCity) setPressSupportCity(spousesAddress.cities?.[0] || "");
      } else if (headOfficeAddress.postalCode) {
        setPressSupportPostalCode(headOfficeAddress.postalCode);
        setInitialPostalCode(headOfficeAddress.postalCode);
        setCities(headOfficeAddress.cities ?? []);
        if (!alreadySetCity) setPressSupportCity(headOfficeAddress.cities?.[0] || "");
      } else if (legalEntity.postalCode) {
        setPressSupportPostalCode(legalEntity.postalCode);
        setInitialPostalCode(legalEntity.postalCode);
        setCities(legalEntity.cities ?? []);
        if (!alreadySetCity) setPressSupportCity(legalEntity.cities?.[0] || "");
      } else if (address.postalCode) {
        setPressSupportPostalCode(address.postalCode);
        setInitialPostalCode(address.postalCode);
        setCities(address.cities ?? []);
        if (!alreadySetCity) setPressSupportCity(address.cities?.[0] || "");
      } else if (individual.postalCode) {
        setPressSupportPostalCode(individual.postalCode);
        setInitialPostalCode(individual.postalCode);
        setCities(individual.cities ?? []);
        if (!alreadySetCity) setPressSupportCity(individual.cities?.[0] || "");
      }

      if (alreadySetCity && (!cities || cities.length === 0)) {
        setCities([pressSupportCity]);
      }
    };

    getPostalCodeIfExists();
  }, [postalCodeProp, pressSupportCity, cities]);

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      const userData = await getUserDetails();

      if (userData) {
        setUser({
          name: userData.name || "",
          firstname: userData.firstname || "",
          email: userData.email || "",
          reference: userData.reference || "",
          civility: userData.civility || "",
          code_parrainage: userData.code_parrainage || "",
          adresse: userData.adresse || "",
          number: userData.number || "",
          country: userData.country || "",
          postal_code: userData.postal_code || "",
          dateCreation: userData.createdAt
            ? new Date(userData.createdAt).toLocaleDateString()
            : "",
          raison_social: userData.raison_social || "",
          code_SIREN: userData.code_SIREN || "",
          code_NAF: userData.code_NAF || "",
          tv_intra: userData.tv_intra || "",
          status: userData.status || "",
        });
      }
      setLoading(false);
    };

    fetchUserData();
  }, []);

  const handlePostalCodeChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;

    if (/^\d{0,5}$/.test(value)) {
      setPressSupportPostalCode(value);

      if (value.length === 5) {
        if (isValidPostalCode(value)) {
          setIsTableLoading(true);
          try {
            const citiesByPostalCode = await getCitiesByPostalCodeString(value);
            
            if (!citiesByPostalCode || citiesByPostalCode.length === 0) {
              message.error("Code postal inexistant. Veuillez vérifier votre saisie.");
              setCities([]);
              setPressSupportCity("");
              setPressData([]);
            } else {
              setCities(citiesByPostalCode);
              setPressSupportCity(citiesByPostalCode?.[0]);
            }
          } catch (error) {
            console.error("Erreur lors de la récupération des villes :", error);
            message.error("Erreur lors de la vérification du code postal.");
            setCities([]);
            setPressSupportCity("");
            setPressData([]);
          } finally {
            setIsTableLoading(false);
          }
        } else {
          message.warning("Le code postal saisi est invalide. Il doit contenir exactement 5 chiffres.");
          setCities([]);
          setPressSupportCity("");
          setPressData([]);
        }
      } else if (value.length < 5 && value.length > 0) {
        setCities([]);
        setPressSupportCity("");
        setPressData([]);
      }
    }
  };

  // ==========================================
  // USEEFFECT : Chargement des supports de presse
  // ==========================================
  useEffect(() => {
    setIsTableLoading(true);
    setLoading(true);

    const fetchData = async () => {
      try {
        if (isValidPostalCode(pressSupportPostalCode)) {
          const departementCode = getDepartementCode(pressSupportPostalCode);
          const nType = selectedType ? selectedType.nType : 1;
          const nStype = selectedType ? selectedType.nSType : 1;
          
          console.log("📡 Chargement supports de presse pour:", {
            postalCode: pressSupportPostalCode,
            departement: departementCode.toString().substring(0, 2),
            nType,
            nStype
          });
          
          const data = await sendSoapRequest(
            txtAnnonce,
            nType,
            nStype,
            departementCode.toString().substring(0, 2),
            pressSupportPostalCode
          );

          await getJalList({
            departement: departementCode.toString().substring(0, 2),
            nSType: nStype,
          }).then(setJalList);

          if (currentAnnoucement) {
            const defaultPress = data.find(
              (item) => item.id === currentAnnoucement.idJal
            );
            setSelectedItem(0);
            if (defaultPress)
              onSupportSelect({
                ...defaultPress,
                postalCode: Number(pressSupportPostalCode),
              });
            setPressData(defaultPress ? [defaultPress] : []);
            setInputDesabled(true);
          } else {
            setPressData(data);
            console.log(`✅ ${data.length} supports chargés`);
            
            if (!data || data.length === 0) {
              message.info("Aucun support de presse disponible pour ce code postal.");
            }
          }
        }
      } catch (error) {
        setError("Erreur lors de la récupération des données");
        message.error("Erreur lors de la récupération des supports de presse.");
        console.log(error);
      } finally {
        setLoading(false);
        setIsTableLoading(false);
      }
    };

    fetchData();
  }, [pressSupportPostalCode, selectedType]);

  // ==========================================
  // NOUVEAU : Gestion du support sélectionné depuis l'extérieur (retour Klarna)
  // ==========================================
  useEffect(() => {
    if (selectedSupport && pressData.length > 0) {
      // Trouver l'index du support dans pressData
      const index = pressData.findIndex(
        (item) => item.id === selectedSupport.id || item.support === selectedSupport.support
      );
      
      if (index !== -1) {
        console.log("✅ Support trouvé dans la liste, sélection automatique:", {
          index,
          support: selectedSupport.support
        });
        setSelectedItem(index);
      } else {
        console.log("⚠️ Support non trouvé dans la liste actuelle:", {
          selectedSupportId: selectedSupport.id,
          selectedSupportName: selectedSupport.support,
          availableSupports: pressData.map(p => ({ id: p.id, name: p.support }))
        });
      }
    }
  }, [selectedSupport, pressData]);

  const getJalInfo = (item: PressData): ReactNode => {
    const jal = jalList.find((j) => j.sId_Jal === item.id);
    if (!jal) return "";

    const parts = [];

    if (jal.nRectifGratuit === "1") parts.push("Rectificatif Offert");
    if (jal.nAdditifGratuit === "1") parts.push("Additif Offert");

    const main = `${item.diffusion === "SPEL" ? "Site Internet" : "Journal"}`;
    const extra = parts.length > 0 ? " - " + parts.join(" - ") : "";

    return (
      <>
        <strong className={`sp-jal-type ${main === "Journal" ? "sp-journal" : "sp-web"}`}>
          {main}
        </strong>
        <span className="sp-jal-extra">{extra}</span>
      </>
    );
  };

  const getDiffusionText = (item: PressData): string => {
    const jal = jalList.find((j) => j.sId_Jal === item.id);
    if (!jal || !jal.nDiffusion) return "";
    return `(${Number(jal.nDiffusion).toLocaleString("fr-FR")} ex)`;
  };

  const convertToDate = (dateString: string): string => {
    const cleanDateString = dateString.substring(0, 8);
    if (cleanDateString.length !== 8) {
      console.error("Format de date incorrect:", dateString);
      return "Date incorrecte";
    }
    const year = cleanDateString.substring(0, 4);
    const month = cleanDateString.substring(4, 6);
    const day = cleanDateString.substring(6, 8);
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    const dayFormatted = date.getDate().toString().padStart(2, "0");
    const monthFormatted = (date.getMonth() + 1).toString().padStart(2, "0");
    const yearFormatted = date.getFullYear();
    return `${dayFormatted}-${monthFormatted}-${yearFormatted}`;
  };

  // helper pour parser l'entete en lignes (nom / adresse / postal+ville)
  const parseEntete = (raw: string) => {
    if (!raw) return { name: "", address: "", postal: "" };
    // d'abord, si l'utilisateur a envoyé avec des sauts de ligne, respecter
    const nlLines = raw.split(/\r?\n/).map(s => s.trim()).filter(Boolean);
    if (nlLines.length >= 3) {
      return {
        name: nlLines[0],
        address: nlLines[1],
        postal: nlLines.slice(2).join(" ")
      };
    }
    if (nlLines.length === 2) {
      return { name: nlLines[0], address: nlLines[1], postal: "" };
    }
    // cas où tout est sur une seule ligne -> essayer d'extraire le code postal (5 chiffres)
    const single = nlLines[0];
    const postalMatch = single.match(/(\d{5}\s*[\p{L}\-\s]*)/u);
    if (postalMatch) {
      const postal = postalMatch[0].trim();
      const before = single.replace(postalMatch[0], "").trim();
      // essayer de séparer nom et adresse par une virgule s'il y en a
      if (before.includes(",")) {
        const parts = before.split(",").map(p => p.trim()).filter(Boolean);
        const name = parts[0] || "";
        const address = parts.slice(1).join(", ");
        return { name, address, postal };
      }
      // sinon essayer de séparer au premier chiffre (n° de rue)
      const firstDigit = before.search(/\d/);
      if (firstDigit > 0) {
        const name = before.substring(0, firstDigit).trim();
        const address = before.substring(firstDigit).trim();
        return { name, address, postal };
      }
      // fallback: tout avant postal -> soit nom, soit adresse. On met tout dans name et postal dans postal
      return { name: before, address: "", postal };
    }
    // impossible d'extraire: on renvoie la ligne entière comme name
    return { name: single, address: "", postal: "" };
  };

  if (loading) {
    return <LoaderSupport />;
  }

  const handleCheckboxChange = (index: number) => {
    const selectedItem = pressData[index];
    let prixHT = Number(selectedItem?.prixHT) || 0;
    let prixTTC = Number(selectedItem?.prixTTC) || 0;
    let prixMajoreHT = prixHT;
    let prixMajoreTTC = prixTTC;

    if (
      selectedType &&
      typeAnnoncePercentages[selectedType.nSType] &&
      typeAnnoncePercentages[selectedType.nSType].discountPercentage
    ) {
      const percentage =
        typeAnnoncePercentages[selectedType.nSType].discountPercentage;
      prixMajoreHT = prixHT + percentage;
      prixMajoreTTC = prixTTC + percentage;
    }

    const itemWithPostalCodeAndPrix = {
      ...selectedItem,
      postalCode: Number(pressSupportPostalCode),
      prixMajoreHT: prixMajoreHT,
      prixMajoreTTC: prixMajoreTTC,
    };
    setSelectedItem(index);
    onSupportSelect(itemWithPostalCodeAndPrix);
  };

  // Fonction pour déterminer le texte d'affichage de l'en-tête
  const getHeaderDisplayText = (): string => {
    if (!choix || choix === 'option1') return '';
    if (choix === 'option2' || choix === 'option3') return entete || '';
    return '';
  };

  // Fonction pour vérifier si on doit afficher le logo
  const shouldDisplayLogo = (): boolean => {
    return (choix === 'option3' || choix === 'option4') && !!floid;
  };

  const headerText = getHeaderDisplayText();
  const displayLogo = shouldDisplayLogo();

  // parse entete en 3 lignes
  const enteteLines = parseEntete(headerText);
  const { name: enteteName, address: enteteAddress, postal: entetePostal } = enteteLines;

  return (
    <div style={{ width: "100%" }}>
      <div style ={{width:"100%"}}>
        <div className="sp-row">
          {/* Section Code Postal */}
          <div className="sp-col-md-6">
            <h6 className="sp-header sp-header-orange">
              CODE POSTAL DE L'ANNONCEUR
            </h6>
            <p className="sp-description">
              Saisir le Code Postal du siège social de la société, ou du fonds
              de commerce en cas de cession, ou du domicile en cas d'annonce
              relative à des personnes.
            </p>
            <p className="sp-description">
              En cas de <span className="sp-fonttext">transfert de siège</span>{" "}
              dans le même département, veuillez indiquer le code postal du
              greffe d'arrivée.
            </p>
            <div className="sp-form-group">
              <label htmlFor="codepostal" className="sp-label">
                Code postal
              </label>
              <div className="sp-input-wrapper">
                <input
                  className="sp-input"
                  type="text"
                  id="codepostal"
                  value={
                    pressSupportPostalCode !== null
                      ? pressSupportPostalCode.toString()
                      : ""
                  }
                  onChange={handlePostalCodeChange}
                  placeholder="Entrez le code postal"
                  readOnly={inputDisabled}
                />
              </div>
            </div>
            <div className="sp-form-group">
              <label htmlFor="ville" className="sp-label">
                Ville
              </label>
              <div className="sp-input-wrapper">
                <select
                  className="sp-select"
                  id="ville"
                  name="ville"
                  value={pressSupportCity}
                  onChange={(event) => setPressSupportCity(event.target.value)}
                  disabled={inputDisabled}
                >
                  {Array.isArray(cities)
                    ? cities.map((city, index) => (
                        <option key={index} value={city}>
                          {city}
                        </option>
                      ))
                    : null}
                </select>
              </div>
            </div>
            {initialPostalCode &&
              pressSupportPostalCode !== initialPostalCode && (
                <p className="sp-warning">
                  Attention vous aviez changé la ville de diffusion de l'annonce
                  legale.
                </p>
              )}
          </div>

          {/* Section Texte de l'annonce */}
          <div className="sp-col-md-6">
            <h6 className="sp-header sp-header-orange">
              TEXTE DE L'ANNONCE
            </h6>
            
            {/* Affichage de l'en-tête et du logo si sélectionnés */}
            {( (enteteName || enteteAddress || entetePostal) || displayLogo) && (
              <div style={{
                marginBottom: '15px',
                padding: '15px',
                backgroundColor: '#f8f9fa',
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                textAlign: 'center'
              }}>
                {/* Logo centré */}
                {displayLogo && (
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '10px'
                  }}>
                    <div style={{
                      width: '90px',
                      height: '90px',
                      border: '2px solid #ddd',
                      borderRadius: '4px',
                      overflow: 'hidden',
                      backgroundColor: '#fff',
                      display: 'inline-block'
                    }}>
                      <img 
                        src={logoLibelle ? `${API_URL}/${logoLibelle}` : ""}
                        alt="Logo sélectionné"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'contain'
                        }}
                        onError={(e) => {
                          console.warn("Impossible de charger le logo:", logoLibelle);
                          (e.target as HTMLImageElement).style.display = 'none';
                        }}
                      />
                    </div>
                  </div>
                )}

                {/* Texte de l'en-tête formaté */}
                <div style={{ display: 'inline-block', textAlign: 'center', maxWidth: '420px' }}>
                  {enteteName && (
                    <div style={{ fontWeight: 700, fontSize: '16px', marginBottom: '6px' }}>
                      {enteteName}
                    </div>
                  )}
                  {enteteAddress && (
                    <div style={{ fontSize: '14px', marginBottom: '6px' }}>
                      {enteteAddress}
                    </div>
                  )}
                  {entetePostal && (
                    <div style={{ fontWeight: 700, fontSize: '14px' }}>
                      {entetePostal}
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="sp-textarea-wrapper">
              <textarea
                className="sp-textarea"
                value={txtAnnonce}
                disabled
                readOnly
              ></textarea>
            </div>
          </div>
        </div>

        <h6 className="sp-header sp-header-orange">
          CHOIX DU SUPPORT PRESSE{" "}
          <span className="sp-bleu">
            (Nous contacter si le journal souhaité n'est pas dans la liste)
          </span>
        </h6>
        <div id="right_panel" className="sp-table-responsive">
          <table className="sp-table">
            <thead>
              <tr>
                <th scope="col">SUPPORT</th>
                <th scope="col">PUBLICATION</th>
                <th scope="col">DIFFUSION</th>
                <th scope="col">PRIX HT</th>
                <th scope="col">PRIX TTC</th>
              </tr>
            </thead>
            <tbody className="sp-scrollable-tbody">
              {isTableLoading ? (
                <tr>
                  <td colSpan={5} className="sp-loading-cell">
                    <div className="loader-support"></div>
                    <p>Chargement des supports de presse...</p>
                  </td>
                </tr>
              ) : (
                (Array.isArray(pressData) ? pressData : [pressData]).map(
                  (item, index) => {
                    let prixHT = Number(item?.prixHT) || 0;
                    let prixTTC = Number(item?.prixTTC) || 0;
                    let prixMajoreHT = prixHT;
                    let prixMajoreTTC = prixTTC;
                    if (
                      selectedType &&
                      typeAnnoncePercentages[selectedType.nSType] &&
                      typeAnnoncePercentages[selectedType.nSType]
                        .discountPercentage
                    ) {
                      const percentage =
                        typeAnnoncePercentages[selectedType.nSType]
                          .discountPercentage;
                      prixMajoreHT = prixHT + percentage;
                      prixMajoreTTC = prixTTC  + percentage;
                    }

                    const uniqueKey = `${item.id || item.support}-${item.publication}`;

                    return (
                      <tr key={uniqueKey}>
                        <td className="sp-support" data-label="SUPPORT">
                          <div className="sp-cell-content">
                            <div className="sp-checkbox-wrapper">
                              <input
                                className="flex pr-5"
                                type="checkbox"
                                checked={selectedItem === index}
                                onChange={() => handleCheckboxChange(index)}
                              />
                            </div>
                            <p className="sp-cell-text">{item?.support}</p>
                          </div>
                        </td>
                        <td className="sp-publication-cell" data-label="PUBLICATION">
                          <div className="sp-cell-content">
                            <div className="sp-icon-wrapper">
                              <FaEdit className="sp-edit-icon" />
                            </div>
                            <p className="sp-cell-text">
                              {convertToDate(item?.publication)}
                            </p>
                          </div>
                        </td>
                        <td className="sp-diffusion-cell" data-label="DIFFUSION">
                          <p className="sp-cell-text">
                            {getJalInfo(item)}
                          </p>
                          <p className="sp-diffusion-count">
                            {getDiffusionText(item)}
                          </p>
                        </td>
                        <td className="sp-prix-cell" data-label="PRIX HT">
                          <p className="d-inline m-0 text-nowrap">
                            {prixMajoreHT.toFixed(2)}{" "}
                            <span className="raise-text">€ HT</span>
                          </p>
                        </td>
                        <td className="sp-prix-cell" data-label="PRIX TTC">
                          <p className="fonttext d-inline m-0 text-nowrap">
                            {prixMajoreTTC.toFixed(2)}{" "}
                            <span className="raise-text">€ TTC</span>
                          </p>
                        </td>
                      </tr>
                    );
                  }
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default SupportPresse;